import { gql } from '@apollo/client';

export const QUERYV2 = gql`
  query GetInvoicesByToken(
    $filter: AutoFilledFilterFindManyinvoicesInput
    $sort: SortFindManyinvoicesInput
    $token: String!
  ) {
    getInvoicesByToken(filter: $filter, sort: $sort, token: $token) {
      companyId
      status
      customerId
      allowedPaymentTypes
      currency
      no
      note
      total
      paid
      amountDue
      amountPaid
      failureReason
      metadata
      bkInvoice
      returnUrl
      globalPayHostedTxId
      globalPayHostedTx
      globalPaySplitPayTx
      hanging
      setupIntent
      subscriptionId
      subscriptionV2Id
      subscriptionScheduledDate
      _id
      updatedAt
      createdAt
      transaction {
        cardNumber
        cardHolder
        cardBrand
      }
      items {
        amount
        name
        description
        total
        type
        unit
        discount
      }
      tax {
        country
        exclusive
        label
        rate
      }
      company {
        name
      }
      customer {
        email
        companyName
        businessNumber
        address {
          address1
          address2
          address3
          city
          zip
          country
        }
      }
    }
  }
`;
